<template>
  <div class="modal member-modal" ref="modalRef" data-bs-backdrop="static" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <img class="member-icon" :class="memberTypeClassRef" :src="iconRef">
          <h1>{{ pmRef?.displayName }}</h1>
          <button type="button" class="btn-close" v-bind="{ disabled: busyRef }" data-bs-dismiss="modal"
            aria-label="Close"></button>
          <div class="member-type">
            <img v-if="memIsGroupOwnerRef" class="owner" src="@/assets/icons/crown.svg"/>
            <template v-if="pmRef?.member">
              {{ memTypeNameRef }}
            </template>
            <template v-else-if="pmRef?.user">
              User
            </template>
            <template v-else>
              Profile managed by {{ profileOwnerRef?.displayName }}
            </template>
          </div>
        </div>
        <div class="modal-body">
          <ul class="nav nav-pills" role="tablist">
            <li class="nav-item">
              <button type="button" id="memberManageTab" class="nav-link active" data-bs-toggle="tab" data-bs-target="#memberManagePane" role="tab" aria-controls="memberManagePane" aria-selected="true">
                Manage
              </button>
            </li>
            <li class="nav-item">
              <button type="button" id="memberHistoryTab" class="nav-link" data-bs-toggle="tab" data-bs-target="#memberHistoryPane" role="tab" aria-controls="memberHistoryPane" aria-selected="false">
                History
              </button>
            </li>
          </ul>
          <div v-if="pmRef" class="tab-content content-area">
            <section id="memberManagePane" class="tab-pane show active" role="tabpanel" aria-labelledby="memberManageTab" tabindex="0">
              <FamilyGroupMemberManage
                :family-group-id="familyGroupId"
                :pm="pmRef"
                @share-profile="inviteShareProfile"
                @remove-profile="onRemoveProfile"
                @remove-user="onRemoveUser"/>
              <template v-if="showChildOptionRef">
                <div class="form-check form-switch child-option">
                  <label for="childCheck" class="form-check-label">
                    Enable child account features
                  </label>
                  <input type="checkbox" id="childCheck" class="form-check-input" v-model="isChildRef" :disabled="!canEditGroupRef" />
                </div>
                <div class="help-text-sm">
                  Enable special features to protect children and their personal information.
                </div>              
              </template>
            </section>
            <section id="memberHistoryPane" class="tab-pane" role="tabpanel" aria-labelledby="memberHistoryTab" tabindex="0">
              <FamilyGroupMemberHistory
                :family-group-id="familyGroupId" 
                :pm="pmRef"
                @view-sharing-invite="onViewSharingInvite"
                @view-group-invite="onViewGroupInvite"/>
            </section>
          </div>
          <!-- <div v-if="showProfileOnlyRef" class="alert alert-primary alert-sm profile-only">
            <template v-if="isSelfProfileRef">
              Your profile is shared with this group, but you are not a group member.
            </template>
            <template v-else>
              This user's profile is shared with the group, but they are not a group member.
            </template>
          </div> -->
        </div>
        <div class="modal-footer">
          <router-link v-if="forProfileRef && familyGroupRef" class="btn btn-outline-primary secondary-action" :to="familyGroupRef.pageUrl">
            View group
          </router-link>
          <router-link v-else-if="pmRef?.user" class="btn btn-outline-primary secondary-action" :to="User.getPageUrl(pmRef.userId)">
            View user
          </router-link>
          <router-link v-else-if="profilePersonIdRef" class="btn btn-outline-primary secondary-action" :to="Person.getPageUrl(profilePersonIdRef)">
            View profile
          </router-link>
          <button type="button" v-if="canAddMemberRef" class="btn btn-primary add-member"
            :disabled="busyRef" @click="onAddMember">
            Add as member
          </button>
          <div v-if="canInviteRef">
            <button type="button" class="btn btn-primary invite"
              :disabled="busyRef" @click="onInvite">
              <img src='@/assets/icons/mail_gray_60.png' />
              Invite
            </button>
          </div>
          <div v-if="canAddUserRef">
            <button type="button" class="btn btn-primary" @click="onAddUser">
              Create child account
            </button>
          </div>
          <button type="button" class="btn btn-outline-primary"
            :disabled="busyRef" data-bs-dismiss="modal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modal-header {
  padding: 1rem 1rem 1rem;
  display: grid;
  grid-template-columns: max-content 1fr max-content;
  grid-column-gap: 0.5rem;
  
  @media (min-width: 768px) {
    padding: 1rem 1.5rem 1rem;
  }

  .member-icon {
    grid-row: 1 / span 2;
    width: 30px;
    opacity: 80%;

    &.user {
      opacity: 60%;
    }

    &.profile {
      opacity: 30%;
    }

    @media (min-width: 768px) {
      width: 45px;
    }
  }

  h1 {
    margin: 0;
    font-size: 1.3rem;

    @media (min-width: 768px) {
      font-size: 1.5rem;
    }
  }

  .member-type {
    color: #888;
    font-size: 0.875rem;

    button {
      margin-left: 0.25rem;
      font-size: 0.75rem;
    }
  }
}

img.owner {
  margin-top: -3px;
  margin-right: 0.3rem;
  width: 1.2rem;
  filter: contrast(0.5) sepia(1) hue-rotate(5deg) saturate(3);
}

.role-info {
  color: #888;
  font-size: 0.875rem;
}

.modal-body {
  min-height: 260px;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0 1rem 0.5rem;

  @media (min-width: 768px) {
    padding: 0 1.5rem 0.5rem;
  }

  .tech-info {
    margin-bottom: -1rem;
  }

}

.alert {
  margin: 0;
}

.scope-rel {
  display: grid;
  grid-template-columns: 2rem 1fr;
  align-items: center;
  color: #888;
  
  img {
    margin-top: -2px;
    margin-right: 0.25rem;
    width: 20px;
    filter: contrast(0.5) brightness(3);
  }

  &.scope-person img {
    filter: contrast(0.5) sepia(1) hue-rotate(130deg) brightness(2.0) saturate(3);
  }
}

.body-action {
  margin-top: 0.25rem;    
}

.deceased {
  font-size: 0.875rem;
  color: #888;
}

.member-role {
  label {
    font-size: 0.875rem;
    color: #888;
  }

  .role-value {
    button {
      margin-left: 0.75rem;
      font-size: 0.875rem;
    }
  }
}

.nav {
  margin: 0;
}

.tab-content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.tab-pane.show {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.member-manage, .member-history {
  margin-top: 0.5rem;
  padding: 0 0.5rem;

  @media (min-width: 768px) {
    padding: 0 1rem;
  }
}

.child-option {
  margin-top: auto;
}

.role-option {
  //font-size: 0.875rem;

  input[type="checkbox"] {
    margin-right: 0.25rem;
  }

  .recruiter-icon {
    margin-top: -5px;
    margin-left: 0.15rem;
    width: 1.1rem;
    opacity: 40%;
  }

  .option-info {
    font-size: 0.75rem;
    color: #888;
  }
}

.date-rel {
  font-size: 0.75rem;  
}

.modal-footer {
  padding: 1rem 1rem;

  @media (min-width: 768px) {
    padding: 1rem 1.5rem;
  }

  button {
    min-width: 100px;
  }

  button.invite img {
    margin-right: 0.5rem;
    width: 1.5rem;    
    filter: invert(1);
  }

  .secondary-action {
    margin-left: 0;
    margin-right: auto;
  }
}
</style>

<script lang="ts" setup>
import { computed, onBeforeUnmount, ref, watch } from 'vue'
import { Person } from '@/rd/ResearchDataModel'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { useDataGroupMemberStore } from '@/gp/DataGroupMemberStore'
import { useFamilyGroupStore } from '@/gp/FamilyGroupStore'
import { useFamilyGroupMemberStore } from '@/gp/FamilyGroupMemberStore'
import { useUserStore } from '@/gp/UserStore'
import { PotentialMember, potentialMemberIcons, useFamilyGroupMemberManager } from './FamilyGroupMemberManager'
import { hideModalAsync, useModalAutoHide } from '@/util/AppUtil'
import { useTokenManager } from '@/auth/TokenManager'
import { GroupMemberRole, PrincipalType, ItemPermissions, User, FamilyGroupMember } from '@/gp/GroupAdminModel'
import { LoadMode } from '@/util/AsyncData'
import { Modal as BsModal, Tab } from 'bootstrap'
import { PatchChange } from '@/util/Api'
import { useUserSupervisorStore } from '@/gp/UserSupervisorStore'
import FamilyGroupMemberHistory from './FamilyGroupMemberHistory.vue'
import FamilyGroupMemberManage from './FamilyGroupMemberManage.vue'

const props = defineProps<{
  familyGroupId: string
}>()

defineExpose({
  open,
  close,
})

const emit = defineEmits<{
  (e: 'shareProfile', profileGroupId: string): void,
  (e: 'removeProfile', pm: PotentialMember): void,
  (e: 'invite', pm: PotentialMember): void,
  (e: 'removeUser', pm: PotentialMember): void,
  (e: 'addUser', pm: PotentialMember): void,
  (e: 'viewSharingInvite', inviteId: string): void,
  (e: 'viewGroupInvite', inviteId: string): void,
}>()

const pmRef = ref<PotentialMember>()
const forProfileRef = ref(false)
const isChildRef = ref(false)
const showHistoryRef = ref(false)
const showChildOptionInfoRef = ref(false)
const busyRef = ref(false)
const modalRef = ref<HTMLElement>()

const dataGroupStore = useDataGroupStore()
const userStore = useUserStore()
const familyGroupStore = useFamilyGroupStore()
const familyGroupMemberStore = useFamilyGroupMemberStore()
const dataGroupMemberStore = useDataGroupMemberStore()
const userSupervisorStore = useUserSupervisorStore()
const memberManager = useFamilyGroupMemberManager()
const tokenManager = useTokenManager()

// basic data objects
const familyGroupRef = computed(() => familyGroupStore.getAsyncGroup(props.familyGroupId)?.data) // loaded by parent
const profilePersonIdRef = computed(() => pmRef.value?.profileGroup?.startItemId)
const profileOwnerRef = computed(() => userStore.getAsyncUser(pmRef.value?.profileGroup?.ownerId)?.data)
const profileGroupMemberRef = computed(() => {
  // NOTE: Get reactive proxy from store so it will be updated if we share/unshare the profile
  return forProfileRef.value
    ? dataGroupMemberStore.getMembersForDataGroups([pmRef.value?.profileGroupId]).find(m => m.principalType == PrincipalType.FamilyGroup && m.principalId == props.familyGroupId) 
    : dataGroupMemberStore.getMembersForFamilyGroups([props.familyGroupId]).find(m => m.dataGroupId == pmRef.value?.profileGroupId)
})
const profilePermissionsRef = computed(() => dataGroupStore.getAsyncPermissions(pmRef.value?.profileGroupId, LoadMode.EnsureLoaded)?.data ?? ItemPermissions.None)
const groupPermissionsRef = computed(() => familyGroupStore.getAsyncPermissions(props.familyGroupId)?.data ?? ItemPermissions.None) // loaded by parent
const supervisedUserIdsRef = computed(() => tokenManager.current.isSupervised ? [] : 
  userSupervisorStore.getForSupervisor(tokenManager.current.userId, LoadMode.EnsureLoaded).map(su => su.forUserId!))

// basic data conditions
const isProfileAdminRef = computed(() => (profilePermissionsRef.value & ItemPermissions.Modify) > 0)
const isUserSupervisorRef = computed(() => pmRef.value?.user && supervisedUserIdsRef.value.includes(pmRef.value.user.id!))
const canEditGroupRef = computed(() => (groupPermissionsRef.value & ItemPermissions.Modify) > 0)
const canAddMembersRef = computed(() => (groupPermissionsRef.value & ItemPermissions.AddItems) > 0)
const personIsDeceasedRef = computed(() => !!pmRef.value?.assumeDeceased)
const profileOwnedByGroupOwnerRef = computed(() => profileOwnerRef.value?.id == familyGroupRef.value?.ownerId)
const profileIsSharedRef = computed(() => !!profileGroupMemberRef.value)
const memIsGroupOwnerRef = computed(() => pmRef.value?.member?.role == GroupMemberRole.Owner)

// UI conditions and values
const memberTypeClassRef = computed(() => pmRef.value?.user ? 'user' : pmRef.value?.profileGroupId ? 'profile' : undefined)
const iconRef = computed(() => pmRef.value?.isSuggested ? potentialMemberIcons.suggested : potentialMemberIcons.person)

const memTypeNameRef = computed(() => pmRef.value?.member?.role == GroupMemberRole.Owner ? "Group owner" : "Group member")

const allowedShareRef = computed(() => canAddMembersRef.value && (isProfileAdminRef.value || profileOwnedByGroupOwnerRef.value))

const canBeInvitedRef = computed(() => !pmRef.value?.profileGroup?.isChild && !pmRef.value?.member && !pmRef.value?.hasPendingGroupInvite && (pmRef.value?.user || (profileIsSharedRef.value && !pmRef.value?.assumeDeceased)))
const canInviteUserRef = computed(() => canBeInvitedRef.value && pmRef.value?.user && canAddMembersRef.value)
const canInviteRef = computed(() => canBeInvitedRef.value && (pmRef.value?.user ? canInviteUserRef : allowedShareRef.value))

const showChildOptionRef = computed(() => !pmRef.value?.user && !personIsDeceasedRef.value && allowedShareRef.value && profileIsSharedRef.value && !pmRef.value?.hasPendingGroupInvite)
const canAddUserRef = computed(() => isProfileAdminRef.value && !pmRef.value?.user && pmRef.value?.profileGroup?.isChild)

const canAddMemberRef = computed(() => profileIsSharedRef.value && !pmRef.value?.member && isUserSupervisorRef.value)

onBeforeUnmount(() => {
  close()
})

function open(pm: PotentialMember, forProfile = false) {
  pmRef.value = pm
  forProfileRef.value = forProfile

  isChildRef.value = pmRef.value?.profileGroup?.isChild ?? false
  showHistoryRef.value = true
  showChildOptionInfoRef.value = false

  // HACK: Not sure why getInstance isn't sufficient here, but sometimes it returns null because apparently the BS Modal
  // hasn't been initialized yet. Calling getOrCreateInstance seems to fix it.
  BsModal.getOrCreateInstance(modalRef.value!).show()

  const memberManageTab = document.querySelector('#memberManageTab')!
  Tab.getOrCreateInstance(memberManageTab).show()
}

function close() {
  BsModal.getInstance(modalRef.value!)?.hide()
}

useModalAutoHide(modalRef)

watch(isChildRef, async () => {
  if (pmRef.value?.profileGroup && isChildRef.value != pmRef.value.profileGroup.isChild) {
    const change = new PatchChange('/isChild', isChildRef.value)
    await dataGroupStore.patchAsync(pmRef.value.profileGroupId!, [change])
  }
})

async function inviteShareProfile(profileGroupId?: string) {
  await hideModalAsync(modalRef.value!)
  emit('shareProfile', profileGroupId ?? pmRef.value!.profileGroupId!)
}

async function onRemoveProfile() {
  await hideModalAsync(modalRef.value!)
  emit('removeProfile', pmRef.value!)
}

async function onRemoveUser() {
  await hideModalAsync(modalRef.value!)
  emit('removeUser', pmRef.value!)
}

async function onAddMember() {
  try {
    busyRef.value = true

    const fm = new FamilyGroupMember()
    fm.familyGroupId = props.familyGroupId
    fm.userId = pmRef.value?.user?.id
    fm.role = GroupMemberRole.Member
    await familyGroupMemberStore.addAsync(fm)
  }
  finally {
    busyRef.value = false
  }
}

async function onInvite() {
  await hideModalAsync(modalRef.value!)
  emit('invite', pmRef.value!)
}

async function onAddUser() {
  await hideModalAsync(modalRef.value!)
  emit('addUser', pmRef.value!)
}

async function onViewSharingInvite() {
  await hideModalAsync(modalRef.value!)
  emit('viewSharingInvite', pmRef.value!.lastSharingInvite!.id!)
}

async function onViewGroupInvite(inviteId: string) {  
  await hideModalAsync(modalRef.value!)
  emit('viewGroupInvite', inviteId)
}

</script>
